export const eventBus = new Vue()

import JobModel from "./JobModel";

const AdminModel = {
    mixins: [JobModel],
    data() {
        return {
            AdminModel: {
                saveFilter: (payload) =>
                    this.$http.post(`/v3/admin/saved-filters`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getSavedFilters: (params) =>
                    this.$http.get(`/v3/admin/saved-filters`, {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                updateSavedFilter: (id, payload) =>
                    this.$http.put(`/v3/admin/saved-filters/${id}`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getSingleFilter: (id) =>
                    this.$http.get(`/v3/admin/saved-filters/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                deleteSavedFilter: (id) =>
                    this.$http.delete(`/v3/admin/saved-filters/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getHiringFunnel: (params) =>
                    this.$http.get(`/v3/admin/metrics/hiring/funnel-stats`, {params})
                        .then(r => r.data, e => Promise.reject(e.data)),
                        
                getTimeToFill: (params) =>
                    this.$http.get(`/v3/admin/metrics/hiring/time-to-fill`, {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                getStageTimingStats: (params) =>
                    this.$http.get(`/v3/admin/metrics/hiring/stage-timing`, {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                getWorkflowStepTiming: (params) =>
                    this.$http.get(`/v3/admin/metrics/hiring/workflow-step-timing`, {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                getTimeToHireStats: (params) =>
                    this.$http.get(`/v3/admin/metrics/hiring/time-to-hire`, {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                getDepartments: (params = { limit: 1000 }) =>
                    this.$http.get(`/v3/admin/departments`, {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                createDepartment: (payload) =>
                    this.$http.post(`/v3/admin/departments`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                syncDepartmentsFromHrms: (payload) =>
                    this.$http.post(`/v3/admin/departments/sync-from-hrms`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                updateDepartment: (payload, id) =>
                    this.$http.put(`/v3/admin/departments/${id}`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                deleteDepartment: (id) =>
                    this.$http.delete(`/v3/admin/departments/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                findDepartment: (id) =>
                    this.$http.get(`/v3/admin/departments/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                        
                getEmployeeProfileFields: () =>
                    this.$http.get(`/v2/admin/hrms/employee-profile-fields`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getDepartmentJobs: (params) =>
                    this.$http.get(`/v2/admin/jobs/list`, {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                getJobBoards: (params) =>
                    this.$http.get(`/v3/admin/job-promotion/job-boards`, {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                applicationSourceSummary: (params) =>
                    this.$http.get('/v2/admin/analytics/application-source-summary', {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                requestMagicLink: (payload) =>
                    this.$http.post(`/v3/auth/magic-link/request`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                validateMagicTokenLogIn: (payload) =>
                    this.$http.post(`/v3/auth/magic-link/validate`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                IDMSLogin: (payload) =>
                    this.$http.post('/v2/admin/login/idms', payload, {
                        onDownloadProgress: evt => eventBus.$emit("idms-login", evt)
                    })
                        .then(r => r.data, e => Promise.reject(e.data)),

                activateOrDeactivateJobBoard: (payload) =>
                    this.$http.post(`/v3/admin/job-boards`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                publishJob: (id, payload) =>
                    this.$http.post(`/v3/admin/job-promotion/promote/${id}`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                createWebhook: (payload) =>
                    this.$http.post(`/v3/admin/webhooks`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                manualWebhookSync: (id) =>
                    this.$http.post(`/v3/admin/webhooks/sync/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                bulkWebhookSync: (payload) =>
                    this.$http.post(`/v3/admin/webhooks/sync-bulk`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
    
                getWebhook: () =>
                    this.$http.get('/v3/admin/webhooks')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getWebhookLogs: (params) =>
                    this.$http.get('/v3/admin/webhooks/logs', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                unPublishJob: (id, payload) =>
                    this.$http.post(`/v3/admin/job-promotion/remove/${id}`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getEligibleAdmins: params =>
                    this.$http.get(`/v2/admin/nudge-admin/get-admins-by-feature/${params}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getApplicantSmartRanking: (id, params) =>
                    this.$http.get(`v2/admin/jobs/${id}/applicants-ranking`, {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                nudgeEligibleAdmins: (payload) =>
                    this.$http.post('v2/admin/nudge-admin', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                addNewInterviewers: (payload, id) =>
                    this.$http.patch(`v2/admin/applicant-interviews/${id}/add-interviewers`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                login: (payload) =>
                    this.$http.post('/v2/admin/login', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                loginAdminWithActiveSession: (payload) =>
                    this.$http.post('/v2/admin/login/hrms', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                resetPassword: (payload) =>
                    this.$http.post('v2/admin/reset-password', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                        
                resetAdminsExpiredPassword: (payload) =>
                    this.$http.post('v2/change-password', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                createAdminPassword: (payload) =>
                    this.$http.post(`v2/admin/create-password`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getClientPrivacyPolicy: () =>
                            this.$http.get(`v2/admin/privacy-policy`)
                                .then(r => r.data, e => Promise.reject(e.data)),

                getTimeAllZones: () =>
                            this.$http.get(`v2/admin/company-settings/timezones/list`)
                                .then(r => r.data, e => Promise.reject(e.data)),
                
                createClientPrivacyPolicy: (payload) =>
                            this.$http.post(`v2/admin/privacy-policy`, payload)
                                .then(r => r.data, e => Promise.reject(e.data)),
               
                validateJobDetails: (payload) =>
                    this.$http.post('v2/admin/jobs/validate-job-details', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                validateJobSettings: (payload) =>
                    this.$http.post('v2/admin/jobs/validate-job-settings', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getSpecializationList: () =>
                    this.$http.get('v2/admin/specializations/list')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getTagsList: () =>
                    this.$http.get('v2/admin/tags/list')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getUserList: () =>
                    this.$http.get('v2/admin/user/all')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getWorkflowsList: (params = {}) =>
                    this.$http.get('v2/admin/workflows/list', {params})
                    .then(r => r.data, e => Promise.reject(e.data)),

                fetchWorkflow: (id) =>
                    this.$http.get(`v2/admin/workflows/find/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                createWorkflow: (payload) =>
                    this.$http.post('v2/admin/workflows/create', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                updateWorkflow: (payload, id) =>
                    this.$http.post(`v2/admin/workflows/${id}/update`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                deleteWorkflow: (id) =>
                    this.$http.delete(`v2/admin/workflows/${id}/delete`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                duplicateWorkflow: (id) =>
                    this.$http.get(`v2/admin/workflows/${id}/duplicate`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchDefaultWorkflowConfirmationMessage: () =>
                    this.$http.get('v2/admin/workflows/default-confirmation-message')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getCurrencies: () =>
                    this.$http.get('v2/fetch-currencies')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getTalentPoolSummary: () =>
                    this.$http.get('v2/admin/analytics/talent-pool-summary')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getQuickStats: () =>
                    this.$http.get('v2/company-dashboard-quick-stats')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getBaseUrl: () =>
                    this.$http.get('v2/admin/tests/get-app-url')
                        .then(r => r.data, e => Promise.reject(e.data)),
 
                // ATS endpoints begin
                fetchOfferLetterStatus: () =>
                    this.$http.get('v2/admin/hrms/verify-admin-exist')
                        .then(r => r.data, e => Promise.reject(e.data)),
                        
                fetchOfferLetterTemplates: company_id =>
                    this.$http.get(`v2/admin/offer-letter/list-templates/${company_id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchPendingApprovals: (jobId) =>
                    this.$http.get(`v2/admin/ats-dashboard/job/${jobId}/pending-approval`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchOfferLetterTemplate: (templateId) =>
                    this.$http.get(`v2/admin/offer-letter/${templateId}/find`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchInsightData: (job_id) =>
                    this.$http.get(`v2/admin/ats-dashboard/applicant-stats-count/${job_id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                restoreArchivedApplications:(jobId) =>
                    this.$http.get(`v2/admin/jobs/${jobId}/restore-applications`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                previewOfferLetter: (template_id) =>
                    this.$http.get(`v2/admin/offer-letter/preview-offer/${template_id}`,  { responseType: 'arraybuffer' })
                        .then(r => r.data, e => Promise.reject(e.data)),

                sendOfferLetter: (payload) =>
                    this.$http.post('v2/admin/offer-letter/send', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                createInterviewNoteTemplate: (payload) =>
                    this.$http.post('v2/admin/interview-note-templates/create', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                editInterviewNoteTemplate: (payload, id) =>
                    this.$http.patch(`v2/admin/interview-note-templates/${id}/update`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchInterviewNoteTemplate: (id) =>
                    this.$http.get(`v2/admin/interview-note-templates/list-interview-note-options/${id}/list`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                // Permission endpoints start
                createRole: ({ payload }) =>
                    this.$http.post('v2/admin/roles', payload)
                            .then(r => r.data, e => Promise.reject(e.data)),

                updateRole: ({ payload , roleId }) =>
                    this.$http.patch(`v2/admin/roles/${roleId}`, payload)
                            .then(r => r.data, e => Promise.reject(e.data)),

                deleteRole: (roleId) =>
                    this.$http.delete(`v2/admin/roles/${roleId}`)
                            .then(r => r.data, e => Promise.reject(e.data)),
                
                fetchRoles: ({ params, isAdminRole = 1 }) =>
                    this.$http.get(`v2/admin/roles?is_admin_role=${isAdminRole}`, { params })
                            .then(r => r.data, e => Promise.reject(e.data)),

                fetchRoleDetails: (role_id) =>
                    this.$http.get(`v2/admin/roles/${role_id}`)
                            .then(r => r.data, e => Promise.reject(e.data)),

                fetchUsersOnRole: (role_id, params) =>
                    this.$http.get(`v2/admin/roles/${role_id}/users`, {params})
                            .then(r => r.data, e => Promise.reject(e.data)),

                listingPermissionsForRole: (type = null) =>
                    this.$http.get(`v2/admin/permission?role_name=${type}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchCompanies: () =>
                    this.$http.get('v2/admin/user/companies')
                        .then(r => r.data, e => Promise.reject(e.data)),

                setupSystemAdmin: (payload) =>
                    this.$http.post(`v2/admin/permission/setup-system-admin`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                verifySystemAdminOTP: ({ userId, otp }) =>
                    this.$http.get(`v2/admin/permission/verify-otp/${userId}/${otp}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchSuperAdmins: () =>
                    this.$http.get('v2/admin/super-admins')
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchJobAdmins: (params) =>
                    this.$http.get('v2/admin/roles/users/list-job-admins', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                removeSuperAdmin: (userId) =>
                    this.$http.delete(`v2/admin/super-admins/${userId}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                toggleActivation: (userId) =>
                    this.$http.get(`v2/admin/super-admins/${userId}/toggle-activation`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                changeAdminRole: (userId, data) =>
                    this.$http.patch(`v2/admin/super-admins/${userId}/change-role`, data)
                        .then(r => r.data, e => Promise.reject(e.data)),

                inviteSuperAdmin: (payload) =>
                    this.$http.post('v2/admin/super-admins/invite', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                checkSystemAdminExists: (userId) =>
                    this.$http.get(`v2/admin/permission/check-system-admin-exist`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                // Permission endpoints end
                getOnboardingDetails: () => {
                    // Check window.appSettings first to avoid API call
                    if (window.appSettings?.onboardingDetails !== undefined) {
	                    return Promise.resolve({ data: window.appSettings.onboardingDetails });
                    }
	                
	                return this.$http.get('v2/user-onboarding-api')
	                  .then(r => r.data, e => Promise.reject(e.data));
                },

                getAuditTrail: (params) =>
                    this.$http.get('v2/admin/audit-trail', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                getAuditTrailActions: () =>
                    this.$http.get('v2/admin/audit-trail/actions')
                        .then(r => r.data, e => Promise.reject(e.data)),

                exportAuditTrailExport: (params) =>
                    this.$http.get('v2/admin/audit-trail/export', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),
               
                postOnboardingDetails: (payload) =>
                    this.$http.post('v2/user-onboarding-api', payload),
                
                fetchPaygrades: company_id =>
                    this.$http.get(`v2/admin/hrms/list-paygrades/${company_id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchJobResourcesFromHRMS: (params) =>
                    this.$http.get('v2/admin/jobs/fetch-job-resources', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchRegions: company_id =>
                    this.$http.get(`v2/admin/hrms/list-regions/${company_id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchJobRoles: (company_id, params = {}) =>
                    this.$http.get(`v2/admin/hrms/list-job-roles/${company_id}`, { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchAllCompanyAdmins: q =>
                    this.$http.get(`v2/admin/get-all-current-company-admins?search=${q}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchDepartments: company_id =>
                    this.$http.get(`v2/admin/hrms/list-departments/${company_id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                createApplicant: (payload) =>
                    this.$http.post('v2/admin/offer-letter/create-applicant', payload),
                    
                fetchRecentActivities: (params) =>
                    this.$http.get('v2/admin/jobs/activity-details', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchRecentConversations: (params) =>
                    this.$http.get(`v2/admin/jobs/recent-conversations`, { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                downloadInterviewNotes: ({ application_ids, job_id, format: format = 'csv' }) =>
                    this.$http.post(`v2/admin/download-applicants-data/${job_id}/interview-notes/${format}
                    `,{ application_ids })
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchEmailTemplates: (params) =>
                    this.$http.get('v2/admin/email-templates', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                createEmailTemplate: ({ payload }) =>
                    this.$http.post('v2/admin/email-templates', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                editEmailTemplate: ({ payload, templateId }) =>
                    this.$http.patch(`v2/admin/email-templates/${templateId}`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchEmailTemplate: (templateId) =>
                    this.$http.get(`v2/admin/email-templates/${templateId}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                deleteEmailTemplate: (templateId) =>
                    this.$http.delete(`v2/admin/email-templates/${templateId}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                deleteComment: (id) =>
                    this.$http.delete(`v2/admin/job-applications/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                duplicateEmailTemplate: (templateId) =>
                    this.$http.get(`v2/admin/email-templates/duplicate/${templateId}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                duplicateInterviewNoteTemplate: ({ payload, templateId }) =>
                    this.$http.post(`v2/admin/interview-note-templates/${templateId}/duplicate`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                deleteInterviewNoteTemplate: (templateId) =>
                    this.$http.delete(`v2/admin/interview-note-templates/${templateId}/delete`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                listInterviewNoteTemplates: (params) =>
                    this.$http.get(`v2/admin/interview-note-templates`, { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                listInterviewNoteOptions: (templateId) =>
                    this.$http.get(`v2/admin/interview-note-templates/list-interview-note-options/${templateId}/list`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                // ATS endpoints end
                
                // Admin Dashboard endpoints start
                nudgePendingMoveRequests: (params = undefined) =>
                    this.$http.get("v2/admin/jobs/dashboard/nudge-pending-move-request", { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                nudgePendingAdminInvites: (params = undefined) =>
                    this.$http.get("v2/admin/jobs/resend/job-team-invite", { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchJobManagersStats: () =>
                    this.$http.get("v2/admin/analytics/job-manager-stats")
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchJobTeamMembers: (params) =>
                        this.$http.get("v2/admin/analytics/job-team-members", { params })
                            .then(r => r.data, e => Promise.reject(e.data)),

                fetchRecruitmentSummaryList: (params) =>
                    this.$http.get('v2/admin/analytics/recruitment-summary', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchRecruitmentSummary: (job_id) =>
                    this.$http.get(`v2/admin/analytics/recruitment-summary/${job_id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                
                fetchNewHires: () =>
                    this.$http.get('v2/admin/analytics/new-hires')
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchPendingTests: () =>
                    this.$http.get('v2/admin/analytics/get-pending-tests')
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchOpenPositions: (params) =>
                    this.$http.get('v2/admin/analytics/get-opened-positions', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchOffersSentThisMonth: () =>
                    this.$http.get('v2/admin/analytics/offers-sent-this-month')
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchPendingInterviews: () =>
                    this.$http.get('v2/admin/analytics/pending-interviews')
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchJobInviteDetails: (id) =>
                    this.$http.get(`v2/job-team-invite/find/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                acceptOrDeclineJobTeamInvite: (id, payload) =>
                    this.$http.post(`v2/job-team-invite/accept-or-decline/${id}`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                // Admin dashboard endpoints end

                getApplicationSetupJobFields: () =>
                    this.$http.get('v2/jobs/fields')
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchCountries: () =>
                    this.$http.get('v2/fetch-selections-data?with=country')
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchLocations: (countryId) =>
                    this.$http.get(`v2/fetch-country-states/${countryId}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchCurrencies: () =>
                    this.$http.get(`v2/fetch-currencies`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchHrmsAdmins: (params = {}) =>
                    this.$http.get(`v2/admin/hrms/list-companies`, { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchJob: (id) => {
                    return this.JobModel.getJob(id)
                        .then((r) => {
                            return r.data
                        })
                },

                createJob: (payload) => {
                    return this.$http.post('v2/admin/jobs/create', payload)
                        .then(r => r.data, e => Promise.reject(e.data))
                },
                
                editJob: (payload, id) => {
                    return this.$http.put(`v2/admin/jobs/update/${id}`, payload)
                        .then(r => r.data, e => Promise.reject(e.data))
                },

                getClientEmbedCode: () =>
                    this.$http.get('v2/admin/jobs/get-client-embed-code')
                        .then(r => r.data, e => Promise.reject(e.data)),
        
                saveSocialAuthSettings: (payload) =>
                    this.$http.post('v2/admin/social-auth-settings', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getSocialAuthSettings: () =>
                    this.$http.get('v2/admin/social-auth-settings')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getNotificationSettings: () =>
                    this.$http.get('v2/admin/company-settings/fetch/notification')
                        .then(r => r.data, e => Promise.reject(e.data)),

                saveNotificationSettings: (payload) =>
                    this.$http.post('v2/admin/company-settings/create/notification', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                
                saveDataRetentionSettings: payload => 
                    this.$http.post('v3/admin/gdpr-policy', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                fetchDataRetentionSettings: () => {
                    // Check window.appSettings first to avoid API call
                    if (window.appSettings?.dataRetentionSettings !== undefined) {
                        return Promise.resolve({ data: window.appSettings.dataRetentionSettings });
                    }
                    // Fallback to API call for backward compatibility
                    return this.$http.get('v3/admin/gdpr-policy')
                        .then(r => r.data, e => Promise.reject(e.data));
                },

                fetchDataRetentionLogs: (params) => 
                    this.$http.get('v3/admin/gdpr-policy/logs', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                getProductNotifications: (params) =>
                    this.$http.get('v2/client/notifications', {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                markAllNotificationAsRead: () =>
                    this.$http.get('v2/client/notifications/read-all')
                        .then(r => r.data, e => Promise.reject(e.data)),

                saveCalendarSettings: (payload) =>
                    this.$http.post('v2/admin/social-auth-settings', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                unpublishJob: (payload) =>
                    this.$http.post('job-status', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getCalendarSettings: () =>
                    this.$http.get('v2/admin/social-auth-settings')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getPasswordResetPolicySettings: () =>
                    this.$http.get('/v2/admin/password-policy')
                        .then(r => r.data, e => Promise.reject(e.data)),
                        
                setPasswordResetPolicySettings: (payload) =>
                    this.$http.post('/v2/admin/password-policy', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getSearchEngineSettings: () => {
                    // Check window.appSettings first to avoid API call
                    if (window.appSettings?.searchEngineSettings) {
	                    return Promise.resolve({
		                    data: window.appSettings.searchEngineSettings
	                    });
			  }
			  
                    // Fallback to API call for backward compatibility
                    return this.$http.get('v2/admin/search-engine-settings')
                        .then(r => r.data, e => Promise.reject(e.data));
                },

                saveMeetingAuth: (type, data) =>
                    this.$http.post(`v2/admin/company-settings/set-${type}-calendar`, data)
                        .then(r => r.data, e => Promise.reject(e.data)),
    
                verifyCalendarAuth: () =>
                    this.$http.get('v2/admin/ms-calendar/verify')
                        .then(r => r.data, e => Promise.reject(e.data)),
    
                getCalendarAuthUrl: urlPrefix =>
                    this.$http.get(`v2/admin/${urlPrefix}/get-auth-url`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                syncAndRefreshApplication: (jobId) =>
                    this.$http.post(`v2/admin/jobs/${jobId}/sync-algolia-index`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                sendBulkMessagesToApplicants: ({ payload, jobId }) =>
                    this.$http.post(`/v2/admin/jobs/${jobId}/bulk-message-applicants`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                updateLandingPageInfo: (data) =>
                    this.$http.post(`v2/admin/company-settings/landing-page-customization/update`, data)
                        .then(r => r.data, e => Promise.reject(e.data)),

                requestAssessmentAccess: (payload) =>
                    this.$http.post('/v3/admin/assessment/access-request', payload || {})
                        .then(r => r.data, e => {
                            const msg = (e && e.response && e.response.data && e.response.data.message) || (e && e.data && e.data.message) || (e && e.message) || 'Request failed';
                            return Promise.reject({ message: msg, response: e && e.response, data: e && e.data });
                        }),
                getAssessmentOverview: (params) =>
                    this.$http.get('/v3/admin/assessment/overview', { params: params || {} })
                        .then(r => r.data, e => Promise.reject(e.data)),
                getAssessmentTests: (params) =>
                    this.$http.get('/v3/admin/assessment/tests', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),
                getAssessmentTest: (id) =>
                    this.$http.get(`/v3/admin/assessment/tests/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                getAssessmentTestingAppUrl: () =>
                    this.$http.get('/v2/admin/tests/get-app-url')
                        .then(r => r.data, e => Promise.reject(e.data)),
                syncAssessmentTests: () =>
                    this.$http.post('/v3/admin/assessment/tests/sync')
                        .then(r => r.data, e => {
                            const msg = (e && e.response && e.response.data && e.response.data.message) || (e && e.data && e.data.message) || (e && e.message) || 'Request failed';
                            return Promise.reject({ message: msg, response: e && e.response, data: e && e.data });
                        }),
                createAssessmentTest: (payload) =>
                    this.$http.post('/v3/admin/assessment/tests', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                updateAssessmentTest: (id, payload) =>
                    this.$http.put(`/v3/admin/assessment/tests/${id}`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                duplicateAssessmentTest: (id, payload) =>
                    this.$http.post(`/v3/admin/assessment/tests/${id}/duplicate`, payload || {})
                        .then(r => r.data, e => {
                            const msg = (e && e.response && e.response.data && e.response.data.message) || (e && e.data && e.data.message) || (e && e.message) || 'Duplicate failed';
                            return Promise.reject({ message: msg, data: e && e.data });
                        }),
                getAssessmentBatches: (params) =>
                    this.$http.get('/v3/admin/assessment/batches', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),
                getAssessmentBatch: (id) =>
                    this.$http.get(`/v3/admin/assessment/batches/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                getBatchScreeningStages: () =>
                    this.$http.get('/v3/admin/assessment/batches/screening-stages')
                        .then(r => r.data, e => Promise.reject(e.data)),
                getBatchResultsSummary: (batchId) =>
                    this.$http.get(`/v3/admin/assessment/batches/${batchId}/results-summary`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                createAssessmentBatch: (payload) =>
                    this.$http.post('/v3/admin/assessment/batches', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                updateAssessmentBatch: (id, payload) =>
                    this.$http.put(`/v3/admin/assessment/batches/${id}`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                deleteAssessmentBatch: (id) =>
                    this.$http.delete(`/v3/admin/assessment/batches/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                getAssessmentJobApplications: (params) =>
                    this.$http.get('/v3/admin/assessment/job-applications', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),
                getJobAssessmentSteps: (jobId) =>
                    this.$http.get(`/v3/admin/assessment/jobs/${jobId}/assessment-steps`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                resolveJobApplicationsByEmails: (payload) =>
                    this.$http.post('/v3/admin/assessment/job-applications/resolve-emails', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                addApplicantToBatch: (batchId, payload) =>
                    this.$http.post(`/v3/admin/assessment/batches/${batchId}/applicants`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                scheduleAssessmentBatch: (batchId) =>
                    this.$http.post(`/v3/admin/assessment/batches/${batchId}/schedule`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                addBulkApplicantsToBatch: (batchId, payload) =>
                    this.$http.post(`/v3/admin/assessment/batches/${batchId}/applicants/bulk`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                getAssessmentBatchSchedulingProgress: (batchJobId) =>
                    this.$http.get(`v2/admin/get-batch/${batchJobId}/assessment-batch-scheduling`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                getAssessmentResults: (params) =>
                    this.$http.get('/v3/admin/assessment/results', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),
                getTestResultsSummary: (testId) =>
                    this.$http.get(`/v3/admin/assessment/results/tests/${testId}/summary`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                getAssessmentResultDetail: (resultId) =>
                    this.$http.get(`/v3/admin/assessment/results/applicant/${resultId}`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                getAssessmentProctoringReport: (resultId) =>
                    this.$http.get(`/v3/admin/assessment/results/applicant/${resultId}/proctoring-report`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                getProctoringSettings: () =>
                    this.$http.get('/v3/admin/assessment/settings/proctoring')
                        .then(r => r.data, e => Promise.reject(e.data)),
                updateProctoringSettings: (payload) =>
                    this.$http.put('/v3/admin/assessment/settings/proctoring', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                setAssessmentProctoringVerdict: (resultId, payload) =>
                    this.$http.post(`/v3/admin/assessment/results/applicant/${resultId}/proctoring-verdict`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                downloadAssessmentProctoringReport: (resultId) =>
                    this.$http.get(`/v3/admin/assessment/results/applicant/${resultId}/proctoring-report.pdf`, { responseType: 'blob' })
                        .then(r => r.data, e => Promise.reject(e)),
                exportAssessmentResults: (params) =>
                    this.$http.get('/v3/admin/assessment/results/export', { params, responseType: 'blob' })
                        .then(r => r.data, e => Promise.reject(e)),
            }
        }
    },
}

export default AdminModel;
